import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';

@Component({
  selector: 'app-adobe-partners',
  templateUrl: './adobe-partners.component.html',
  styleUrls: ['./adobe-partners.component.scss']
})
export class AdobePartnersComponent implements OnInit {
  @ViewChild('slides', { static: false }) slides: IonSlides;

  constructor() { }

  ngOnInit(): void { }

  slidesSuccess = {
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    autoplay: false,
    centeredSlides: true,
    zoom: false,
    // breakpoints: {
    //   320: { slidesPerView: 1 },
    //   500: { slidesPerView: 1 },
    //   767: { slidesPerView: 1},
    // }
  };

  prevSlide() {
    this.slides.slidePrev();
  }

  nextSlide() {
    this.slides.slideNext();
  }
}

